const ProfilePage = () => <div>User Profile</div>;

export default ProfilePage;
